import React from 'react';
import { ShieldPlus, MessageCircle } from 'lucide-react';
import { CONTACT } from './Constants';
export function InsuranceSection() {
  return <section className="py-16 bg-celeste-light/50" data-id="element-170">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-171">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-sm mb-6 text-celeste" data-id="element-172">
          <ShieldPlus className="w-8 h-8" data-id="element-173" />
        </div>
        <h2 className="text-3xl font-bold text-azul mb-6" data-id="element-174">
          Tu salud es lo primero
        </h2>
        <p className="text-lg text-gray-700 mb-6" data-id="element-175">
          Trabajamos junto a Fonasa y todas las Isapres del país para que tu
          atención tenga el respaldo que necesitas durante tu proceso.
        </p>
        <p className="text-sm text-gray-500 italic mb-8" data-id="element-176">
          La disponibilidad y condiciones pueden variar según cada caso.
          Escríbenos para recibir orientación.
        </p>
        <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3 border border-transparent rounded-full shadow-sm text-base font-semibold text-white bg-whatsapp hover:bg-whatsapp-hover transition-colors" data-id="element-177">
          <MessageCircle className="w-5 h-5 mr-2" data-id="element-178" />
          Consultar por WhatsApp
        </a>
      </div>
    </section>;
}